/* eslint-disable no-underscore-dangle */
const AmazonCognitoIdentity = require('amazon-cognito-identity-js');


const SignIn = (username, password) => {
  const poolData = {
    UserPoolId: process.env.VUE_APP_AWS_USER_POOL_ID, // Your user pool id here
    ClientId: process.env.VUE_APP_AWS_USER_CLIENT_ID, // Your client id here
  };

  const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

  const authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails({
    Username: username,
    Password: password,
  });

  const userData = {
    Username: username,
    Pool: userPool,
  };
  const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

  return new Promise((resolve, reject) => {
    // eslint-disable-next-line func-names
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess(result) {
        // console.log(result);
        // eslint-disable-next-line no-console
        // console.log(`access token + ${result.getAccessToken().getJwtToken()}`);
        // // eslint-disable-next-line no-console
        // console.log(`id token + ${result.getIdToken().getJwtToken()}`);
        // // eslint-disable-next-line no-console
        // console.log(`refresh token + ${result.getRefreshToken().getToken()}`);

        const _result = {
          accessToken: result.getAccessToken().getJwtToken(),
          idToken: result.getIdToken().getJwtToken(),
          refreshToken: result.getRefreshToken().getToken(),
        };

        return resolve(_result);
      },
      onFailure(err) {
        // eslint-disable-next-line no-console
        console.log(err);
        return reject(err);
      },
    });
  });
};

export {
  SignIn as
  default,
};
